import { useImagerySlots } from "../../../../hooks/use-imagery";
import { ErrorState, LoadingSpinner } from "../../../ui/loading";
import { ImagerySlotCard } from "./imagery-slot-card";

interface Props {
  recordId: string | undefined;
}

export function ImagerySlotsRow({ recordId }: Props): React.ReactElement {
  const { data, isLoading, isError, error } = useImagerySlots(recordId);

  if (recordId && isLoading) {
    return (
      <div className="flex justify-center py-6">
        <LoadingSpinner />
      </div>
    );
  }

  if (recordId && isError) {
    return <ErrorState message={error instanceof Error ? error.message : "Failed to load images"} />;
  }

  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <ImagerySlotCard slotName="aerial" label="Aerial Photo" recordId={recordId} slot={data?.aerial ?? null} />
      <ImagerySlotCard slotName="flood" label="Flood Hazards" recordId={recordId} slot={data?.flood ?? null} />
    </div>
  );
}
